import { Typography } from "@mui/material"
import { sanitize } from "isomorphic-dompurify"
import { useTranslation } from "react-i18next"

import { richTextSx } from "../../../@shared/rich-text"

interface Props {
	description: string | undefined
}

export const Prompt = ({ description }: Props) => {
	const { t } = useTranslation("vote")

	return (
		<>
			<Typography
				textAlign='center'
				mb={1}
				variant='h6'
				component='h2'
				textTransform='uppercase'
				fontWeight='bold'
			>
				{t("artistsPrompt")}
			</Typography>
			<Typography
				component='div'
				textAlign='center'
				sx={richTextSx}
				dangerouslySetInnerHTML={{
					__html: sanitize(description ?? ""),
				}}
			/>
		</>
	)
}
